import { SITE_URL, buildCanonicalUrl } from './site';

export const SITE_NAME = 'CSSBuy Spreadsheet';

export interface FaqEntry {
  q: string;
  a: string;
}

export function buildWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: SITE_URL,
    description:
      'Explore o CSSBuy Spreadsheet com produtos, links, guias de compra, QC, armazém, envio e comparações em um único recurso.',
    inLanguage: ['pt-BR', 'en', 'de'],
  };
}

export function buildOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: SITE_URL,
  };
}

export function buildFaqPageSchema(faqs: FaqEntry[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };
}

export interface ArticleSchemaOptions {
  title: string;
  description: string;
  image: string;
  path: string;
  datePublished: string;
  dateModified: string;
}

export function buildArticleSchema(options: ArticleSchemaOptions) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: options.title,
    description: options.description,
    image: options.image,
    author: { '@type': 'Organization', name: SITE_NAME },
    publisher: { '@type': 'Organization', name: SITE_NAME },
    datePublished: options.datePublished,
    dateModified: options.dateModified,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': buildCanonicalUrl(options.path),
    },
  };
}